
const themes = {
    blue: {
      '--background': '0 0% 100%',
      '--foreground': '222.2 84% 4.9%',
      '--card': '0 0% 100%',
      '--card-foreground': '222.2 84% 4.9%',
      '--popover': '0 0% 100%',
      '--popover-foreground': '222.2 84% 4.9%',
      '--primary': '221.2 83.2% 53.3%',
      '--primary-gradient': '221 65% 79%',
      '--primary-foreground': '210 40% 98%',
      '--secondary': '210 40% 96.1%',
      '--secondary-foreground': '222.2 47.4% 11.2%',
      '--muted': '210 40% 96.1%',
      '--muted-foreground': '215.4 16.3% 46.9%',
      '--accent': '210 40% 96.1%',
      '--accent-dark': '206 18% 92%',
      '--accent-foreground': '222.2 47.4% 11.2%',
      '--destructive': '0 84.2% 60.2%',
      '--destructive-foreground': '210 40% 98%',
      '--border': '214.3 31.8% 91.4%',
      '--input': '214.3 31.8% 91.4%',
      '--ring': '221.2 83.2% 53.3%',
      '--radius': '0.5rem',
    },
    navy: {
      '--background': '0 0% 100%',
      '--foreground': '222.2 84% 4.9%',
      '--card': '0 0% 100%',
      '--card-foreground': '222.2 84% 4.9%',
      '--popover': '0 0% 100%',
      '--popover-foreground': '222.2 84% 4.9%',
      '--primary': '205.7 100% 19.2%',
      '--primary-gradient': '205 65% 79%',
      '--primary-foreground': '210 40% 98%',
      '--secondary': '210 40% 96.1%',
      '--secondary-foreground': '222.2 47.4% 11.2%',
      '--muted': '210 40% 96.1%',
      '--muted-foreground': '215.4 16.3% 46.9%',
      '--accent': '210 40% 96.1%',
      '--accent-dark': '206 18% 92%',
      '--accent-foreground': '222.2 47.4% 11.2%',
      '--destructive': '0 84.2% 60.2%',
      '--destructive-foreground': '210 40% 98%',
      '--border': '214.3 31.8% 91.4%',
      '--input': '214.3 31.8% 91.4%',
      '--ring': '221.2 83.2% 53.3%',
      '--radius': '0.5rem'
    },
    abyss: {
      '--background': '0 0% 100%',
      '--foreground': '222.2 84% 4.9%',
      '--card': '0 0% 100%',
      '--card-foreground': '222.2 84% 4.9%',
      '--popover': '0 0% 100%',
      '--popover-foreground': '222.2 84% 4.9%',
      '--primary': '221.5 57.3% 17.6%',
      '--primary-gradient': '221 65% 79%',
      '--primary-foreground': '210 40% 98%',
      '--secondary': '210 40% 96.1%',
      '--secondary-foreground': '222.2 47.4% 11.2%',
      '--muted': '210 40% 96.1%',
      '--muted-foreground': '215.4 16.3% 46.9%',
      '--accent': '208 100% 96%',
      '--accent-dark': '221 57% 12%',
      '--accent-foreground': '222.2 47.4% 11.2%',
      '--destructive': '0 84.2% 60.2%',
      '--destructive-foreground': '210 40% 98%',
      '--border': '214.3 31.8% 91.4%',
      '--input': '214.3 31.8% 91.4%',
      '--ring': '221.2 83.2% 53.3%',
      '--radius': '0.5rem'
    },
    darkgreen: {
      '--background': '144 23% 95%',
      '--foreground': '145 47% 20%',
      '--card': '144 23% 95%',
      '--card-foreground': '145 47% 20%',
      '--popover': '144 23% 95%',
      '--popover-foreground': '145 47% 20%',
      '--primary': '145 47% 29%',
      '--primary-gradient': '145 30% 60%',
      '--primary-foreground': '144 23% 95%',
      '--secondary': '144 28% 85%',
      '--secondary-foreground': '145 47% 20%',
      '--muted': '144 28% 85%',
      '--muted-foreground': '145 24% 50%',
      '--accent': '144 28% 85%',
      '--accent-dark': '145 47% 20%',
      '--accent-foreground': '145 47% 20%',
      '--destructive': '0 84.2% 60.2%',
      '--destructive-foreground': '144 23% 95%',
      '--border': '145 20% 60%',
      '--input': '145 20% 60%',
      '--ring': '145 47% 29%',
      '--radius': '0.5rem'
    },
    green: {
      '--background': '141 23% 95%',
      '--foreground': '144 35% 20%',
      '--card': '141 23% 95%',
      '--card-foreground': '144 35% 20%',
      '--popover': '141 23% 95%',
      '--popover-foreground': '144 35% 20%',
      '--primary': '144 35% 45%',
      '--primary-gradient': '144 30% 70%',
      '--primary-foreground': '141 23% 95%',
      '--secondary': '141 28% 85%',
      '--secondary-foreground': '144 35% 20%',
      '--muted': '141 28% 85%',
      '--muted-foreground': '144 20% 50%',
      '--accent': '141 28% 85%',
      '--accent-dark': '144 35% 30%',
      '--accent-foreground': '144 35% 20%',
      '--destructive': '0 84.2% 60.2%',
      '--destructive-foreground': '141 23% 95%',
      '--border': '144 15% 80%',
      '--input': '144 15% 80%',
      '--ring': '144 35% 45%',
      '--radius': '0.5rem'
    },
    olive: {
      '--background': '60 10% 96%',
      '--foreground': '88 66% 15%',
      '--card': '60 10% 96%',
      '--card-foreground': '88 66% 15%',
      '--popover': '60 10% 96%',
      '--popover-foreground': '88 66% 15%',
      '--primary': '88 70% 50%',
      '--primary-gradient': '88 50% 80%',
      '--primary-foreground': '60 10% 96%',
      '--secondary': '60 25% 90%',
      '--secondary-foreground': '88 66% 15%',
      '--muted': '60 25% 90%',
      '--muted-foreground': '88 34% 46%',
      '--accent': '60 25% 90%',
      '--accent-dark': '88 66% 25%',
      '--accent-foreground': '88 66% 15%',
      '--destructive': '0 84.2% 60.2%',
      '--destructive-foreground': '60 10% 96%',
      '--border': '88 20% 80%',
      '--input': '88 20% 80%',
      '--ring': '88 70% 50%',
      '--radius': '0.5rem'
    },
    rose: {
      '--background': '0 0% 100%',
      '--foreground': '240 10% 3.9%',
      '--card': '0 0% 100%',
      '--card-foreground': '240 10% 3.9%',
      '--popover': '0 0% 100%',
      '--popover-foreground': '240 10% 3.9%',
      '--primary': '346.8 77.2% 49.8%',
      '--primary-gradient': '347 57% 76%',
      '--primary-foreground': '355.7 100% 97.3%',
      '--secondary': '240 4.8% 95.9%',
      '--secondary-foreground': '240 5.9% 10%',
      '--muted': '240 4.8% 95.9%',
      '--muted-foreground': '240 3.8% 46.1%',
      '--accent': '240 4.8% 95.9%',
      '--accent-dark': '347 77% 35%',
      '--accent-foreground': '240 5.9% 10%',
      '--destructive': '0 84.2% 60.2%',
      '--destructive-foreground': '0 0% 98%',
      '--border': '240 5.9% 90%',
      '--input': '240 5.9% 90%',
      '--ring': '346.8 77.2% 49.8%',
      '--radius': '0.5rem',
    },
    burgundy: {
      '--background': '0 0% 100%',
      '--foreground': '322.7 60.7% 19.4%',
      '--card': '0 0% 100%',
      '--card-foreground': '322.7 60.7% 19.4%',
      '--popover': '0 0% 100%',
      '--popover-foreground': '322.7 60.7% 19.4%',
      '--primary': '322.7 60.7% 34.1%',
      '--primary-gradient': '322 65% 79%',
      '--primary-foreground': '300 25% 95%',
      '--secondary': '300 25% 95%',
      '--secondary-foreground': '322.7 60.7% 19.4%',
      '--muted': '300 25% 95%',
      '--muted-foreground': '322.7 30% 50%',
      '--accent': '300 25% 95%',
      '--accent-dark': '322.7 60.7% 20%',
      '--accent-foreground': '322.7 60.7% 19.4%',
      '--destructive': '0 84.2% 60.2%',
      '--destructive-foreground': '300 25% 95%',
      '--border': '322.7 30% 80%',
      '--input': '322.7 30% 80%',
      '--ring': '322.7 60.7% 34.1%',
      '--radius': '0.5rem'
    },
    maroon: {
      '--background': '330 100% 97%',
      '--foreground': '330 100% 20%',
      '--card': '330 100% 97%',
      '--card-foreground': '330 100% 20%',
      '--popover': '330 100% 97%',
      '--popover-foreground': '330 100% 20%',
      '--primary': '0 100% 25%',
      '--primary-gradient': '0 29% 64%',
      '--primary-foreground': '330 100% 97%',
      '--secondary': '330 50% 85%',
      '--secondary-foreground': '330 100% 20%',
      '--muted': '330 50% 85%',
      '--muted-foreground': '330 50% 50%',
      '--accent': '330 50% 85%',
      '--accent-dark': '0 100% 15%',
      '--accent-foreground': '330 100% 20%',
      '--destructive': '0 84.2% 60.2%',
      '--destructive-foreground': '330 100% 97%',
      '--border': '0 29% 64%',
      '--input': '0 29% 64%',
      '--ring': '0 100% 25%',
      '--radius': '0.5rem'
    },
};

export default themes;